import { render, staticRenderFns } from "./FooterLinks.vue?vue&type=template&id=25295a39&scoped=true"
import script from "./FooterLinks.vue?vue&type=script&lang=js"
export * from "./FooterLinks.vue?vue&type=script&lang=js"
import style0 from "./FooterLinks.vue?vue&type=style&index=0&id=25295a39&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25295a39",
  null
  
)

export default component.exports